<template>
  <div>
    <loading-block v-if="!loaded"></loading-block>
    <v-card v-else>
      <v-card-title>
        <v-text-field
          prepend-icon="search"
          v-model="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>

      <v-data-table
        class="px-5 py-3 pb-5 tabulardata"
        :headers="headers"
        :items="listItem"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        @page-count="pageCount = $event"
        :search="search"
      >
        <template v-slot:[`item.name`]="{ item }">
          <div v-if="item.image">
            <img
              :src="item.image"
              style="width:60px; height:auto; vertical-align:middle;"
              :alt="item.name"
            />
            <span style="margin-left:10px;">{{ item.name }}</span>
          </div>
          <div v-else style="display:inline-block;">
            <v-icon style="font-size:60px !important; border-radius:none;"
              >fa-image</v-icon
            >
            <span
              class="font-weight-bold"
              v-if="!item.parent_category"
              style="margin-left:10px;"
              >{{ item.name }}</span
            >
            <span v-else style="margin-left:30px;">{{ item.name }}</span>
          </div>
        </template>

        <template v-slot:[`item.featured`]="{ item }">
          <v-icon v-if="item.featured" color="primary">mdi-star</v-icon>
          <v-icon v-else>mdi-star</v-icon>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="recommendItem(item.id)">
                <v-btn v-on="on" fab small dark color="primary" class="mr-2" depressed>
                  <v-icon dark>mdi-thumb-up-outline</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Recommendations</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="setInventoryThreshold(item)">
                <v-btn
                  v-on="on"
                  fab
                  small
                  dark
                  color="primary"
                  class="mr-2"
                  depressed
                >
                  <v-icon dark>mdi-counter</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Set Inventory Threshold</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a v-on:click.prevent="setProductFamily(item)">
                <v-btn
                  v-on="on"
                  fab
                  small
                  dark
                  color="primary"
                  class="mr-2"
                  depressed
                >
                  <v-icon dark>mdi-group</v-icon>
                </v-btn>
              </a>
            </template>
            <span>Set Product Family</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on:click.prevent="editItem(item)"
                v-on="on"
                fab
                small
                dark
                color="primary"
                class="mr-2"
                depressed
              >
                <v-icon dark>edit</v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>

          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on:click.prevent="deleteItem(item)"
                v-on="on"
                fab
                small
                dark
                color="primary"
                depressed
              >
                <v-icon dark>delete</v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <p class="mb-0">No data.</p>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { LocationCategoryAPI } from '@/clients/location/location.category.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      loaded: false,
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'Name', value: 'name', sortable: true, width: 250 },
        { text: 'Description', value: 'description', sortable: false },
        { text: 'Featured', value: 'featured', sortable: true },
        { text: 'Actions', value: 'action', sortable: false, width: 300 }
      ],
      listItem: []
    }
  },
  computed: {
    ...mapGetters({
      threshholdModal: 'locationcategory/threshholdPop',
      selectedLocation: 'location/selected',
      addModal: 'locationcategory/addPop',
      editModal: 'locationcategory/editPop'
    })
  },
  async created() {
    try {
      this.loaded = false
      await this.locationCategoryList()
      this.loaded = true
    } catch (err) {
      this.loaded = true
    }
  },
  watch: {
    editModal(value) {
      if (value === false) {
        this.locationCategoryList();
      }
    },
    addModal(value) {
      if (value === false) {
        this.locationCategoryList()
      }
    },
    threshholdModal(value) {
      if (value === false) {
        this.locationCategoryList()
      }
    }
  },
  methods: {
    setInventoryThreshold(item) {
      this.setThreshholdObj(item)
      this.setThreshholdPop(true)
    },
    setProductFamily(item) {
      this.setProductObj(item)
      this.setProductPop(true)
    },
    async locationCategoryList() {
      try {
        if (this.selectedLocation.id !== undefined) {
          const { data } = await LocationCategoryAPI.fetch(this.selectedLocation.id)
        this.listItem = []
        data.payload.forEach(each => {
          if (each.parent_category === null) {
            this.listItem.push(each)
            if (each.subCategory.length > 0) {
              this.listItem = [...this.listItem, ...each.subCategory]
            }
          }
        })
        } else {
          this.listItem = []
        }
      } catch (err) {
        this.listItem = []
      }
    },

    /**
     * Function accept object which has an id
     */
    deleteItem(obj) {
      document.activeElement.blur()
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete ${obj.name}.`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        customClass: {
          container: 'custom-swal'
        }
      }).then(async function (result) {
        if (result.value) {
          self.spinner(true)
          let result = await LocationCategoryAPI.delete(obj.id)
          self.spinner(false)
          if (result.status === 200) {
            self.$swal(
              'Deleted!',
              `${obj.name} successfully deleted.`,
              'success'
            )
            self.locationCategoryList()
          } else {
            self.$swal(
              'Failed!',
              'Please try again later.',
              'error'
            )
          }
        }
      })
    },

    /**
     * Edit popup setup
     */
    editItem(obj) {
      this.setEditPop(true)
      this.setEditObj(obj)
    },

    ...mapActions({
      setEditPop: 'locationcategory/setEditPop',
      setEditObj: 'locationcategory/setEditObj',
      setThreshholdPop: 'locationcategory/setThreshholdPop',
      setThreshholdObj: 'locationcategory/setThreshholdObj',
      setProductPop: 'locationcategory/setProductPop',
      setProductObj: 'locationcategory/setProductObj',
      setRecommendPop: 'category/setRecommendPop',
      setRecommendObj: 'category/setRecommendObj'
    }),

    recommendItem(id) {
      this.setRecommendObj(id)
      this.setRecommendPop(true)
    }
  }
}
</script>
